import { z } from "zod";
const digest = z.string().regex(/^[a-f0-9]{64}$/u);
const identifier = z.string().trim().min(1).max(200);
/** Server-verified execution evidence. This does not certify answer meaning. */
export const runExecutionProofEventPayloadSchema = z.object({
    schemaVersion: z.literal("mlx.run-execution-proof.v1"),
    runId: identifier,
    attemptNumber: z.number().int().positive(),
    certificates: z.array(z.object({
        certificateId: identifier,
        certificateSha256: digest,
        publicationVersionId: identifier.nullable(),
        productSlug: z.string().trim().min(1).max(120).nullable(),
        productVersion: z.number().int().positive().nullable(),
        queriedRelations: z.array(z.string().trim().min(1).max(300)).min(1).max(256),
        rowCount: z.number().int().nonnegative().nullable(),
        columnCount: z.number().int().nonnegative().nullable(),
        complete: z.boolean().nullable(),
        resultAvailable: z.boolean(),
        compactFactsComplete: z.boolean().nullable(),
        canonicalResultSha256: digest,
    }).strict()).max(256),
}).strict().superRefine((proof, context) => {
    const ids = proof.certificates.map((certificate) => certificate.certificateId);
    if (new Set(ids).size !== ids.length) {
        context.addIssue({ code: "custom", path: ["certificates"],
            message: "Execution proof certificates must be unique." });
    }
});
